<app-header [currentUrl]="currentUrl"></app-header>
<div class="main-container bg-beige">
  <div class="app-containerv2">
    <main class="main">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
